<template>

  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" :disabled="showBigButtons" @click="cancel()">{{ (showBigButtons) ? "" : t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ props.title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="showBigButtons" @click="confirm()" :strong="true">{{ (showBigButtons) ? "" : t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div v-show="showBigButtons" id="header">
      <ion-grid>
        <div v-show="showScrollButtons">
          <ion-row >
            <ion-col size="4">
              <ion-button  class="general-big-button cancel-button-color done-button-width" @click="cancel()">{{ t("Cancel") }}</ion-button>      
            </ion-col>
            <ion-col size="4">
              <ion-button class="general-big-button done-button-color done-button-width" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
            </ion-col>
            <ion-col size="2">
              <ion-button  class="general-big-button scroll-button-color scroll-button-width" @click="scrollPage('up')">{{ t("Scroll Up") }}</ion-button>
            </ion-col>
            <ion-col size="2">
              <ion-button  class="general-big-button scroll-button-color scroll-button-width" @click="scrollPage('down')">{{ t("Scroll Down") }}</ion-button>
            </ion-col>
          </ion-row>
        </div>
        <div v-show="!showScrollButtons">
          <ion-row >
            <ion-col size="6">
              <ion-button  class="general-big-button cancel-button-color done-button-width" @click="cancel()">{{ t("Cancel") }}</ion-button>      
            </ion-col>
            <ion-col size="6">
              <ion-button class="general-big-button done-button-color done-button-width" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
            </ion-col>
  
          </ion-row>
        </div>
      </ion-grid>
    </div>  
  </ion-header>

  <ion-content>
    <div id="page">
      <ion-radio-group :value="props.initialValue" @ionChange="selectionChange($event)">
        <div v-for="(item,i) in props.displayArray" :key="item.id">
        <ion-radio :id="item.radio" :value="item.radio" :aria-label="item.value" label-placement="end">
          <span class="ion-text-wrap">{{ item.name }}</span>
        </ion-radio>
        </div>
      </ion-radio-group>
    </div>
  </ion-content>
</template>

<script  setup>

// https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport

  import {
    IonGrid,IonRow,IonCol,
    IonRadio,
    IonRadioGroup,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    modalController,
  } from '@ionic/vue';

  import { defineComponent, ref , onMounted, watch } from 'vue';
  import { t } from '@/composables/translateText.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { availableWidthHeight, isScreenPortraitOrientation} from '@/composables/screenSize'

  const props = defineProps({
    title : {
      type : String,
      default : "TITLE"
    },
    displayArray : {
      type : Array,
      default : []
    },
    initialValue : {
      type :String,
      default : "1"
    },
    forceBigButtons : {
      type : Boolean,
      default : false
    }
	})

  //console.log("values",props.displayArray)

  // get button ids so we can scroll by elelment id
  var idArray = []
  for (var i=0; i < props.displayArray.length; i++)
    idArray.push(props.displayArray[i].radio)
  //console.log("id array ",idArray)
  var currentScrollIndex = 0
  var scrollIncrement = 1

  const selectedValue = ref(props.initialValue)

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(props.forceBigButtons || whichMenu == "buttons" || connectionStore.getShowBigButtons)
  const scalePercentage = connectionStore.getToolbarScalePercentage

  const radioButtonHeight = 30
  const useRadioButtonHeight = (showBigButtons.value) ? Math.floor( radioButtonHeight * scalePercentage / 100.0) :
                radioButtonHeight
  const doneButtonHeight = 50
  const useDoneButtonHeight = (showBigButtons.value) ? Math.floor( doneButtonHeight * scalePercentage / 100.0) :
                doneButtonHeight
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const showScrollButtons = ref(true)

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    buildStyles()
  })

  onMounted(() => {
    var element = document.getElementById("page")
    if (element != null)
      element.style.setProperty("--radio_button_size", useRadioButtonHeight + "px");
    element = document.getElementById("header")
    if (element != null)
      element.style.setProperty("--done_button_size", useDoneButtonHeight + "px");
    buildStyles()
  })

  function buildStyles() {

    const modalHeight = (window.innerHeight || document.documentElement.clientHeight)
    const headingHeight = (showBigButtons.value) ? (useDoneButtonHeight + 50) : 0
    const spaceForButtons = modalHeight - headingHeight
    //console.log("spaceforbuttons",spaceForButtons)

    // if room for all buttons, don't display scroll buttons
    showScrollButtons.value = spaceForButtons < (useRadioButtonHeight + 8) * props.displayArray.length
    scrollIncrement = Math.floor(spaceForButtons / (useRadioButtonHeight + 8) )
    if (scrollIncrement == 0)
      scrollIncrement = 1
    //console.log("Scroll Increment",scrollIncrement)
  }

  function scrollPage(direction) {
    if (direction == "up") {
      if (currentScrollIndex > 0)
        currentScrollIndex -= scrollIncrement;
      if (currentScrollIndex < 0)
        currentScrollIndex = 0
    }
    else {
      if (currentScrollIndex < idArray.length -1)
        currentScrollIndex += scrollIncrement
      if (currentScrollIndex > idArray.length -1)
        currentScrollIndex = idArray.length -1
    }
    const id = idArray[currentScrollIndex]
    const element = document.getElementById(id)
    //console.log("Scroll to Element",element)
    if (element != null)
      element.scrollIntoView({ behavior: "smooth" })
    //scrollElement("page",direction)
  }

  function cancel() {
    modalController.dismiss(null, 'cancel');
  }

  function confirm() {
    var result = { selected : selectedValue.value}

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function selectionChange(ev) {
    //console.log("selection Change",ev.detail)
    //console.log('Current value:', JSON.stringify(ev.detail.value));
    selectedValue.value = ev.detail.value
  }

</script>

<style scoped>

#page {
  --radio_button_size : 30px;
}

ion-radio::part(container) {
    width: var(--radio_button_size);
    height: var(--radio_button_size);

    border-radius: 8px;
    border: 2px solid #ddd;
  }

  ion-radio::part(mark) {
    background: none;
    transition: none;
    transform: none;
    border-radius: 0;
  }

  ion-radio.radio-checked::part(container) {
    background: #6815ec;
    border-color: transparent;
  }

  ion-radio.radio-checked::part(mark) {
    width: 6px;
    height: 10px;

    border-width: 0px 2px 2px 0px;
    border-style: solid;
    border-color: #fff;

    transform: rotate(45deg);
  }

#header {
  --done_button_size : 50px;
}

.title_text {
  background-color: #0d6efd;
  text-align: center;
  font-size: 24px;
}

.done-button-width {
  width : 100%;
}
.scroll-button-width {
  width : 100%;
}

.action-button-color {
  --background: teal;       /* Teal background */
}
.action-button-width {
  width : 100%;
}

</style>
